import { cn } from "@/libs/utils/tailwind/cn";
import TrustpilotWhiteIcon from "./assets/TrustpilotWhiteIcon";

export default function TrustBadges({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "w-fit inline-flex items-center gap-2 rounded-xl bg-background/10 px-4 py-2 text-sm font-medium text-white whitespace-nowrap",
        className
      )}
    >
      4.9/5 on

      <TrustpilotWhiteIcon className="w-20 mb-1"/>

      (12k+ reviews)
    </div>
  );
}
